// quadruple-click.directive.ts
import { Directive, HostListener, output } from '@angular/core';

@Directive({
  selector: '[appQuadrupleClick]',
})
export class QuadrupleClickDirective {
  private clickCount = 0;
  private timeout: any;

  readonly quadrupleClick = output<MouseEvent>();

  @HostListener('click', ['$event'])
  handleClick(event: MouseEvent): void {
    this.clickCount++;

    if (this.clickCount === 4) {
      this.quadrupleClick.emit(event);
      this.reset();
    } else {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.reset(), 400); // 400ms window for 4 clicks
    }
  }

  private reset(): void {
    this.clickCount = 0;
    clearTimeout(this.timeout);
  }
}
